import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Alert } from 'reactstrap'

export const ErrorPageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background-color: rgba(255,255,255,0.65);  
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
`

const ErrorOverlay = ({ message }) => (
  <ErrorPageContainer>
    <Alert color='danger'>
      {message}
    </Alert>
  </ErrorPageContainer>
)

ErrorOverlay.propTypes = {
  message: PropTypes.string.isRequired
}
export default ErrorOverlay
